import type { Styles } from '@adornis/ass/style.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('marketing-topbar-dialog')
export class MarketingTopbarDialog extends XNativeDialog<void> {
  @property({ attribute: false }) widthOfNav: Maybe<number>;

  override render() {
    if (!this.widthOfNav) return html``;
    return html` ${super.render()} `;
  }

  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        dialog: {
          // position
          height: '100%',
          width: `${this.widthOfNav}px`,
          maxWidth: '100%',
          maxHeight: '100%',
          // others
          background: 'transparent',
          boxShadow: 'none',
          animation: 'none',
          margin: '0',
          transition: 'none',
        },
        'dialog x-flex, dialog d-flex': {
          height: '100%',
        },
        'dialog::backdrop': {
          display: 'none',
        },
      },
    ];
  }
}
